// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.2502 4.33594V11.3359L18.2502 4.33594V19.6644L11.2502 12.6644V19.6644L3.58594 12.0002L11.2502 4.33594Z"}}]};

const BackwardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'backward-filled',
    ref,
    icon: element,
  },
));

BackwardFilledIcon.displayName = 'BackwardFilledIcon';

export default BackwardFilledIcon;
